import { utilities } from './../../../utils/utilities';
import { AuthService } from 'src/auth/auth.service';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-errror',
  templateUrl: './errror.component.html',
  styleUrls: ['./errror.component.scss']
})
export class ErrrorComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router:Router, private authService:AuthService, @Inject(DOCUMENT) private document: Document ) { }

  public errorMessage = "";
  public detailedMessage = "";

  ngOnInit() {
    this.route.queryParamMap.subscribe(param => {
      this.errorMessage = param.get("error");
      this.detailedMessage = param.get("message");
      console.error(this.errorMessage);
      console.error(this.detailedMessage);

      utilities.RemoveAllCookies();
      sessionStorage.clear();
      this.router.navigateByUrl("/logoff");     
    });
  }

}
